import * as z from "zod";

export const getRechargeIntegration = {
  name: "getRechargeIntegration" as const,
  input: z.null(),
  output: z.object({
    exists: z.boolean(),
    apiToken: z.string().optional(),
    clientSecret: z.string().optional(),
  }),
};
